module.exports = __webpack_public_path__ + "static/media/icon-header-preview.16ab059f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Header/assets/icon-header-preview.svg
// module id = 1509
// module chunks = 193